module.exports = __webpack_public_path__ + "img/edit2.21e84732.svg";